"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _clock = require("./clock.styles");

var _clock2 = _interopRequireDefault(require("../../components/clock"));

var _svgElements = require("../../components/svg-elements");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var Clock = function Clock(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      progressPercentage = _ref.progressPercentage,
      disableHover = _ref.disableHover,
      name = _ref.name;
  var clockConfig = config || _hotspot.clock;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_clock.ClickableAreaStyled, {
    onClick: onClick,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, _react.default.createElement(_clock.ExpandingBoundingBoxStyled, null), iconPosition && _react.default.createElement(_clock.ClockContainer, {
    config: config,
    iconPosition: iconPosition
  }, _react.default.createElement(_svgElements.Svg, {
    preserveAspectRatio: "xMinYMin",
    height: "80%",
    width: "80%",
    className: "clock-svg",
    style: {
      borderRadius: '50%'
    },
    viewBox: "0 0 64 64"
  }, _react.default.createElement(_clock2.default, {
    progressPercentage: progressPercentage,
    r: "25%",
    cx: "50%",
    cy: "50%",
    primaryColor: clockConfig.primaryColor,
    strokeOpacity: "1",
    opacity: "0.5"
  })), _toConsumableArray(Array(2)).map(function (_, i) {
    return _react.default.createElement(_svgElements.Svg, {
      height: "100%",
      width: "100%",
      className: "circle-wrapper svg-".concat(i),
      viewBox: "0 0 100 100",
      key: "svg-".concat(i + 0)
    }, _react.default.createElement(_svgElements.Circle, {
      cx: "50%",
      cy: "50%",
      r: "40%",
      fill: "none",
      strokeWidth: "7",
      stroke: clockConfig.primaryColor,
      className: "ring"
    }));
  })));
};

var _default = Clock;
exports.default = _default;